export const noticeList = [
  'PRODUCT.OPTION.IMAGE_FORM_NOTICE_1',
  'PRODUCT.OPTION.IMAGE_FORM_NOTICE_2',
  'PRODUCT.OPTION.IMAGE_FORM_NOTICE_3',
  'PRODUCT.OPTION.IMAGE_FORM_NOTICE_4',
];
